import { render, staticRenderFns } from "./Portals.vue?vue&type=template&id=e63e82e8&"
import script from "./Portals.vue?vue&type=script&lang=ts&"
export * from "./Portals.vue?vue&type=script&lang=ts&"
import style0 from "./Portals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports